import type { SheetDraft } from './types'

export function uppercaseText(value: string | null | undefined): string {
  return (value || '').toLocaleUpperCase('es-ES')
}

export function isDeadObservation(value: string | null | undefined): boolean {
  return /\bMUERTO\b/i.test(value || '')
}

export function normalizeRing(value: string): string {
  const compact = value.trim().toUpperCase().replace(/[^A-Z0-9]/g, '')
  if (!compact) return ''
  const match = compact.match(/^([A-Z]+)(\d+)$/)
  return match ? `${match[1]}-${match[2]}` : value.trim().toUpperCase().replace(/\s+/g, '-')
}

const PREFIX_DOUBT = 'Prefijo inesperado para este año'

export function applyChickPrefixRule(draft: SheetDraft, expectedPrefix: string): SheetDraft {
  const expected = expectedPrefix.toLocaleUpperCase('es-ES').replace(/[^A-Z]/g, '')
  const doubtfulFields = (draft.doubtfulFields || []).filter(item => !item.motivo.startsWith(PREFIX_DOUBT))
  if (expected) {
    draft.pichones.forEach((chick, index) => {
      const actual = normalizeRing(chick.anilla).match(/^([A-Z]+)-?\d+/)?.[1]
      if (actual && actual !== expected) doubtfulFields.push({
        campo: `pichones.${index}.anilla`,
        motivo: `${PREFIX_DOUBT}: se espera ${expected} y se ha leído ${actual}. No se ha cambiado automáticamente.`
      })
    })
  }
  return { ...draft, doubtfulFields }
}

export function emptyDraft(): SheetDraft {
  return {
    anio: new Date().getFullYear(),
    hoja: 1,
    padre: { nombre: '', anilla: '', plumaje: '' },
    madre: { nombre: '', anilla: '', plumaje: '' },
    pichones: []
  }
}

export function validateDraft(draft: SheetDraft): string[] {
  const errors: string[] = []
  if (draft.anio < 1900 || draft.anio > 2200) errors.push('Indica un año válido.')
  if (!Number.isInteger(draft.hoja) || draft.hoja < 1) errors.push('El número de hoja debe ser mayor que 0.')
  return errors
}

export function normalizeDraft(draft: SheetDraft): SheetDraft {
  return {
    ...draft,
    padre: { ...draft.padre, nombre: uppercaseText(draft.padre.nombre), anilla: normalizeRing(draft.padre.anilla), plumaje: uppercaseText(draft.padre.plumaje) },
    madre: { ...draft.madre, nombre: uppercaseText(draft.madre.nombre), anilla: normalizeRing(draft.madre.anilla), plumaje: uppercaseText(draft.madre.plumaje) },
    pichones: draft.pichones.map(item => ({ ...item, nombre: uppercaseText(item.nombre), anilla: normalizeRing(item.anilla), plumaje: uppercaseText(item.plumaje), sexo: uppercaseText(item.sexo), observaciones: uppercaseText(item.observaciones) }))
  }
}
